import { render, staticRenderFns } from "./CompanySettingsRow.vue?vue&type=template&id=96fd84c4"
import script from "./CompanySettingsRow.vue?vue&type=script&lang=js"
export * from "./CompanySettingsRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports